import { BACKEND_API_URL } from "../Config"
import { fetchWithAuth, handleApiResponse } from "../Utils";


export const localLogin = async ({ email, password, onSuccess, onError }) => {
    try {
        const response = await fetch(`${BACKEND_API_URL}/auth/login/local`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ email, password })
        });

        const data = await handleApiResponse(response, "localLogin");

        if (onSuccess) onSuccess(data);
        return data;
    } catch (error) {
        if (onError) {
            onError(error);
            return;
        }
        throw error;
    }
};

export const bindPassword = async ({ auth, rawPassword, onSuccess, onError }) => {
    try {
        const response = await fetchWithAuth(
            `${BACKEND_API_URL}/auth/sns-login/bind-password`,
            {
                method: "POST",
                body: JSON.stringify({ password: rawPassword })
            },
            auth
        );

        const data = await handleApiResponse(response, "bindPassword");

        if (onSuccess) onSuccess(data);
        return data;
    } catch (error) {
        if (onError) {
            onError(error);
            return;
        }
        throw error;
    }
};

export const requestTokenRefresh = async (refreshToken) => {
    try {
        const refreshResponse = await fetch(`${BACKEND_API_URL}/auth/refresh`, {
            method: 'POST',
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                refreshToken: refreshToken,
            })
        });

        if (!refreshResponse.ok) return null;

        const data = await refreshResponse.json();

        return data.accessToken;
    } catch (error) {
        console.error("Error refreshing token: ", error);
        return null;
    }
};

export const checkEmailAvailability = async ({ email, onSuccess, onError }) => {
    try {
        const response = await fetch(
            `${BACKEND_API_URL}/auth/check-email?email=${encodeURIComponent(email)}`
        );

        const data = await handleApiResponse(response, "checkEmailAvailability");

        if (onSuccess) onSuccess(data);

        return data;
    } catch (error) {
        if (onError) {
            onError(error);
            return;
        }
        throw error;
    }
};

export const localRegister = async ({ payload, onSuccess, onError }) => {
    try {
        const response = await fetch(
            `${BACKEND_API_URL}/auth/register/local`,
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(payload),
            }
        );

        const data = await handleApiResponse(response, "localRegister");

        if (onSuccess) onSuccess(data);

        return data;
    } catch (error) {
        if (onError) {
            onError(error);
            return;
        }
        throw error;
    }
};

export const requestForgotPasswordReset = async ({ email, onSuccess, onError }) => {
    try {
        const response = await fetch(`${BACKEND_API_URL}/auth/forgot-password`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ to: email })
        });

        const data = await handleApiResponse(response, "requestForgotPasswordReset");

        if (onSuccess) onSuccess(data);
        return data;
    } catch (error) {
        if (onError) {
            onError(error);
            return;
        }
        throw error;
    }
};

export const setNewPassword = async ({ token, password, onSuccess, onError }) => {
    try {
        const response = await fetch(`${BACKEND_API_URL}/auth/set-new-password`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                token: token,
                password: password
            })
        });

        const data = await handleApiResponse(response, "setNewPassword");

        if (onSuccess) onSuccess(data);

        return data;
    } catch (error) {
        if (onError) {
            onError(error);
            return;
        }
        throw error;
    }
};

export const verifyEmail = async ({ token, onSuccess, onError }) => {
    try {
        const response = await fetch(
            `${BACKEND_API_URL}/auth/verify-email`,
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ token: token }),
            }
        );

        const data = await handleApiResponse(response, "verifyEmail");

        if (onSuccess) onSuccess(data);

        return data;
    } catch (error) {
        if (onError) {
            onError(error);
            return;
        }
        throw error;
    }
};

export const resendVerificationEmail = async ({ email, password, onSuccess, onError }) => {
    try {
        const response = await fetch(
            `${BACKEND_API_URL}/auth/resend-verification-email`,
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    email: email,
                    password: password
                }),
            }
        );

        const data = await handleApiResponse(response, "resendVerificationEmail");

        if (onSuccess) onSuccess(data);

        return data;
    } catch (error) {
        if (onError) {
            onError(error);
            return;
        }
        throw error;
    }
}

export const fetchUserHasPassword = async ({ auth, onSuccess=null, onError=null }) => {
    try {
        const url = `${BACKEND_API_URL}/auth/has-password`;

        const response = await fetchWithAuth(
            url,
            { 
                method: 'GET'
            },
            auth
        );

        const data = await handleApiResponse(response, "fetchUserHasPassword");

        if (onSuccess) onSuccess(data);
        return data;
    }
    catch (error) {
        if (onError) {
            onError(error);
            return
        }
        throw error;
    }
}

export const requestPasswordChange = async ({ auth, password, onSuccess, onError }) => {
    try {
        const url = `${BACKEND_API_URL}/auth/request-password-change`;

        const response = await fetchWithAuth(
            url, 
            {
                method: "POST",
                body: JSON.stringify({ password: password })
            },
            auth
        );

        const data = await handleApiResponse(response, "requestPasswordChange");

        if (onSuccess) onSuccess(data);
        return data;
    } catch (error) {
        if (onError) {
            onError(error);
            return;
        }
        throw error;
    }
};

export const requestPasswordSetup = async ({ auth, onSuccess, onError }) => {
    try {
        const url = `${BACKEND_API_URL}/auth/request-password-setup`;

        const response = await fetchWithAuth(
            url, 
            {
                method: "POST",
            },
            auth
        );

        const data = await handleApiResponse(response, "requestPasswordSetup");

        if (onSuccess) onSuccess(data);
        return data;
    } catch (error) {
        if (onError) {
            onError(error);
            return;
        }
        throw error;
    }
};